import React from "react";
import { components } from "react-select";
import { REVIEW_GATE_OPTION_CLASS, REVIEW_GATE_OPTION_TIP_IDS } from "../utils/qaGateValidation";

function ReviewGateSelectOption(props) {
    const { data, isDisabled } = props;
    const tipId = REVIEW_GATE_OPTION_TIP_IDS[data.value] || null;
    const htmlTip = data.criteriaTipHtml || (isDisabled ? data.disabledTipHtml : null);
    const textTip = isDisabled ? data.disabledTip : null;
    const hasTip = !!tipId && (htmlTip || textTip);
    const statusClass = REVIEW_GATE_OPTION_CLASS[data.value] || "";

    return (
        <components.Option {...props}>
            <span
                className={[statusClass, isDisabled ? "review-gate-option--blocked" : ""].filter(Boolean).join(" ")}
                {...(hasTip
                    ? {
                          "data-for": tipId,
                          "data-tip": " ",
                          "data-delay-show": "100",
                          "data-effect": "solid",
                          "data-place": "left",
                          "data-background-color": "#1e293b",
                          "data-class": htmlTip ? "qa-gate-criteria-tooltip" : "review-gate-option-tooltip",
                          ...(htmlTip ? { "data-html": true } : {})
                      }
                    : {})}
            >
                {data.label}
            </span>
        </components.Option>
    );
}

export default ReviewGateSelectOption;
